import {
  UPLOADS_URL,
  UPLOAD_URL,
  SEARCH_UPLOADS_URL,
  MOMENTS_URL,
  QR_GEN_TEMPLATES_URL
} from 'app/utils/Constants';

import {
  get,
  post,
  put
} from 'app/services/ApiService';

export const getUploads = async params => {
  return await post(SEARCH_UPLOADS_URL(), params);
}

export const getUpload = async (accountId, id) => {
  return await get(UPLOAD_URL(accountId, id));
}

export const createUpload = async (accountId, params) => {
  return await post(UPLOADS_URL(accountId), params);
}

export const updateUpload = async (accountId, id, params) => {
  return await put(UPLOAD_URL(accountId, id), params);
}

export const createMoments = async params => {
  params.v2 = true;
  return await post(MOMENTS_URL(), params);
}

export const uploadQRTemplate = async (jobId, params) => {
  return await post(QR_GEN_TEMPLATES_URL(jobId), params);
}

